import { useState } from 'react';

const FAQ_ITEMS = [
  {
    q: '52吃瓜网的内容多久更新一次？',
    a: '我们的编辑团队每天7×24小时轮班监控全网热点，首页内容实时滚动更新。通常情况下，重大八卦事件发生后15分钟内就会有第一条快讯上线，后续会持续跟进深度报道和时间线整理。日均更新量稳定在120条以上。',
  },
  {
    q: '52吃瓜网的八卦信息来源可靠吗？',
    a: '我们采用多源交叉验证机制，每条资讯在上线前都会经过至少两个独立信源的比对。对于未经证实的传闻，我们会明确标注"待核实"标签。我们的编辑团队中有多位资深娱乐记者，确保内容的专业性和可信度。',
  },
  {
    q: '如何向52吃瓜网投稿或提供线索？',
    a: '你可以通过本站的联系我们页面提交爆料信息，也可以发送邮件至 tips@52chigua.com。所有投稿和线索都会得到严格保密处理。如果你的爆料被采用，我们会在报道中给予匿名致谢。欢迎每一位吃瓜群众的参与！',
  },
  {
    q: '52吃瓜网有手机App吗？如何使用？',
    a: '52吃瓜网已推出iOS和Android双平台客户端，支持推送通知、离线阅读、夜间模式和个性化订阅。你可以在App Store或各大安卓应用商店搜索"52吃瓜网"下载。App端与网页端数据同步，随时随地想吃就吃。',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            为你解答
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">常见问答</h2>
        </div>

        <div className="space-y-3">
          {FAQ_ITEMS.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">{item.q}</h3>
                <span className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-full transition-colors ${openIndex === i ? 'bg-primary-500 text-white' : 'bg-background-200 text-foreground-500'}`}>
                  <i className={`text-sm ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </span>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4 pt-0">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}